/* eslint-disable func-names */
import store from '~/store';
import can from '~/helpers/can';

/**
 * Navigation guard to prevent user to access a route if he does not have the correct permissions
 * @param to
 * @param from
 * @param next
 */
export default function (to, from, next) {
  const { user } = store.state.auth;
  const userAccessCode = user ? user.access_code : null;
  const { matched } = to;
  if (!matched || matched.length === 0) {
    return next();
  }

  // We will check the permissions on the last matched route
  const route = matched[matched.length - 1];
  const { resource, actionPermission } = route.meta;
  if (resource && userAccessCode) {
    // Default: View UI (16). Some routes require specific actions via meta.actionPermission.
    const action = actionPermission ?? 16;
    const hasAccess = can(userAccessCode, action, resource);

    if (!hasAccess) {
      return next({ name: 'forbidden' });
    }
  }

  return next();
}
